
































































































































































































































import {
  dateFormat,
  getCurrentMonth,
  getCurrentWeek,
} from "@/utils/timeFormat";
import createSettlementDialog from "../tabStore/createSettlementDialog.vue";
import { exportLoop } from "@/utils/export";
import {
  getSalaryTeacherStatisticsApi,
  exportSalaryTeacherStatisticsApi,
  exportSalaryTeacherStatisticsData,
} from "@/api/salary";
import eventBus from "@/utils/bus";
import { mixin } from "@/mixin/tabPageInfoMixin";
import { Vue, Component, Mixins } from "vue-property-decorator";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  name: "salaryTabAchievements",
  components: {
    createSettlementDialog,
    commonDateRangeSelector,
  },
})
export default class extends Mixins(mixin) {
  searchInfo: any = {
    lesson_date: [],
  };
  currentTimeType: string = "current_month";
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [10];
  total: number = 0;
  created() {
    // this.mixinGetPageInfo("salaryTabAchievements");
    if (this.searchInfo.lesson_date.length === 0) {
      this.searchRangeChange(this.currentTimeType);
    } else {
      // 有缓存
      this.currentTimeType = "";
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    }
  }
  toStoreTab() {
    eventBus.$emit("quickly-create-salary-settlement");
  }
  handleExport() {
    const option: exportSalaryTeacherStatisticsData = {
      lesson_start_date: "",
      lesson_end_date: "",
    };
    if (this.searchInfo.name) {
      option.name = this.searchInfo.name;
    }
    if (
      this.searchInfo.lesson_date &&
      this.searchInfo.lesson_date.length === 2
    ) {
      option.lesson_start_date = this.searchInfo.lesson_date[0];
      option.lesson_end_date = this.searchInfo.lesson_date[1];
    } else {
      this.$message({
        type: "warning",
        message: "请先选择时间",
      });
      return false;
    }
    exportSalaryTeacherStatisticsApi(option).then((res: any) => {
      exportLoop(res.data.task_id);
    });
  }
  handleLessonDateChange() {
    this.currentTimeType = "";
    this.handleSearch();
  }
  searchRangeChange(type: string) {
    let start: string = "";
    let end: string = "";
    const now = new Date();
    this.currentTimeType = type;
    switch (type) {
      case "current_week":
        const cw = getCurrentWeek(now);
        start = dateFormat("YYYY-mm-dd", cw[0]);
        end = dateFormat("YYYY-mm-dd", now);
        break;
      case "prev_week":
        const pw = getCurrentWeek(now.getTime() - 7 * 24 * 60 * 60 * 1000);
        start = dateFormat("YYYY-mm-dd", pw[0]);
        end = dateFormat("YYYY-mm-dd", pw[1]);
        break;
      case "current_month":
        const cm = getCurrentMonth(now);
        start = dateFormat("YYYY-mm-dd", cm[0]);
        end = dateFormat("YYYY-mm-dd", now);
        break;
      case "prev_month":
        const d = now.getDate();
        const pm = getCurrentMonth(now.getTime() - d * 24 * 60 * 60 * 1000);
        start = dateFormat("YYYY-mm-dd", pm[0]);
        end = dateFormat("YYYY-mm-dd", pm[1]);
        break;
    }
    this.searchInfo.lesson_date = [start, end];
    this.handleSearch();
  }
  getList(params: { page: number; page_size: number }) {
    const option: any = {
      page: params.page,
      page_size: params.page_size,
    };
    if (this.searchInfo.name) {
      option.name = this.searchInfo.name;
    }
    if (
      this.searchInfo.lesson_date &&
      this.searchInfo.lesson_date.length === 2
    ) {
      option.lesson_start_date = this.searchInfo.lesson_date[0];
      option.lesson_end_date = this.searchInfo.lesson_date[1];
    } else {
      this.$message({
        type: "warning",
        message: "请先选择上课时间",
      });
      return false;
    }
    getSalaryTeacherStatisticsApi(option).then((res: any) => {
      if (res.error_code === 0) {
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.page = res.data.page;
      }
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  toRollcallLesson(common: any, course_type: number) {
    const params: any = {
      teacher_id: common.teacher.teacher_id,
      teacher_name: common.teacher.name,
      lesson_date: this.searchInfo.lesson_date,
    };
    if (course_type) {
      params.course_type = course_type;
    }
    sessionStorage.setItem(
      "salary-achievements-link-to-rollcall-list",
      JSON.stringify(params)
    );
    const url = `${window.location.origin}/#/layout/teaching/roll_call?tab=rollCallRecord`;
    window.open(encodeURI(url), "_blank");
  }
  toRollcallStudent(common: any, student_status_list: string) {
    const params: any = {
      teacher_id: common.teacher.teacher_id,
      teacher_name: common.teacher.name,
      lesson_date: this.searchInfo.lesson_date,
      student_status_list: student_status_list,
    };
    sessionStorage.setItem(
      "salary-achievements-link-to-rollcall-student-list",
      JSON.stringify(params)
    );
    const url = `${window.location.origin}/#/layout/teaching/roll_call?tab=rollCallStudentList`;
    window.open(encodeURI(url), "_blank");
  }
  toExperienceList(data: any) {
    const params: any = {
      teacher_id: data.teacher.teacher_id,
      teacher_name: data.teacher.name,
      lesson_date: this.searchInfo.lesson_date,
      experience_statu: 2,
    };
    sessionStorage.setItem(
      "salary-achievements-link-to-experience-student-list",
      JSON.stringify(params)
    );
    setTimeout(() => {
      const url = `${window.location.origin}/#/layout/recruit/experience?from=salary_tab_achievements`;
      window.open(encodeURI(url), "_blank");
    }, 500);
  }
}
